import * as React from 'react';

import Carousel from 'antd/lib/carousel';

import PetMemorialGallerySlide from '@app/components/Pages/PetMemorial/PetMemorialGallerySlide';
import imagePlaceholder from '@app/images/image-placeholder.png';
import PetMemorialThumb from '@app/components/Pages/PetMemorial/PetMemorialThumb';
import {getImagePath} from '@app/objects/Image';

const PetMemorialGallery = ({navCollapse, modalProps}) => {

	const [activeThumb, setActiveThumb] = React.useState(0);
	const [mainImage, setMainImage] = React.useState((modalProps.memorial.images?.length && modalProps.memorial.images[activeThumb]) || undefined);
	const slider = React.useRef<any>();

	const showThumb = (index) => {
		setActiveThumb(index);
		setMainImage(modalProps.memorial.images[index]);
	};

	React.useEffect(() => {
		showThumb(0);
	}, [modalProps.memorial.images]);
	const sliderItems = modalProps.memorial.images;

	const {memorial} = modalProps;
	const imageAltCapture = `Lap of Love Veterinary Hospice ${memorial.city ? memorial.city : ''}, ${memorial.state ? memorial.state : ''} ${memorial.petName ? `${memorial.petName}'s memorial ${memorial.firstName ? `by ${memorial.firstName} ${memorial.lastName}` : ''}` : ''}`;
	return (
		navCollapse
		?
			modalProps.memorial.images?.length ?
		<div className="pet-mem-modal__content-gallery-slider">
			<Carousel
				ref={slider}
				slidesToShow={1}
				slidesToScroll={1}
				dots={true}
				infinite={true}
				swipeToSlide={true}
			>
				{/*{modalProps.memorial.images.length && modalProps.memorial.images.map((item, index) => (*/}
				{sliderItems.length && sliderItems.map((item, index) => (
					<PetMemorialGallerySlide key={index} index={index} item={item} />
				))}
			</Carousel>
		</div> : null
		:
		// ----------------------MODAL-GALLERY-DESKTOP-----------------
			modalProps.memorial.images?.length ?
		<div className="pet-mem-modal__content-gallery">
			<img
				src={mainImage !== imagePlaceholder ? getImagePath(mainImage, 420) : mainImage}
				alt={imageAltCapture}
				className={modalProps.memorial.images.length === 1 ?
					'pet-mem-modal__content-gallery-main_single' :
					'pet-mem-modal__content-gallery-main'}
				onError={() => {
					setMainImage(imagePlaceholder);
				}}
			/>
			{
				modalProps.memorial.images.length && modalProps.memorial.images.length < 4
				&& modalProps.memorial.images.length > 1 ?
					<div>
						{
							modalProps.memorial.images.length === 2 ?
								<div
									className="pet-mem-modal__content-gallery-nav pet-mem-modal__content-gallery-nav_two">
									{
										modalProps.memorial.images.map((item, index) => (
											<PetMemorialThumb
												key={index}
												index={index}
												item={item}
												activeThumb={activeThumb}
												showThumb={showThumb}
												imageAltCapture={imageAltCapture}
											/>
										))
									}
								</div>
								:
								<div
									className="pet-mem-modal__content-gallery-nav pet-mem-modal__content-gallery-nav_three">
									{
										modalProps.memorial.images.map((item, index) => (
											<PetMemorialThumb
												key={index}
												index={index}
												item={item}
												activeThumb={activeThumb}
												showThumb={showThumb}
												thumbHeight={260}
												thumbWidth={260}
												imageAltCapture={imageAltCapture}
											/>
										))
									}
								</div>
						}
					</div> :
					<div
						className="pet-mem-modal__content-gallery-nav">
						{
							modalProps.memorial.images.length !== 1 &&
							modalProps.memorial.images.slice(0, 6).map((item, index) => (
								<PetMemorialThumb
									key={index}
									index={index}
									item={item}
									activeThumb={activeThumb}
									showThumb={showThumb}
									thumbHeight={120}
									thumbWidth={120}
									imageAltCapture={imageAltCapture}
								/>
							))
						}
					</div>
			}
		</div> : null
	);
};

export default PetMemorialGallery;